import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { serviceFields } from '@services/api'

export class servicefieldsStore extends StoreExt {
    @observable list = []
    @observable filteredList = []
    @observable error = null
    @observable filters = {
        name: ''
    }
    @observable editServicefield = {}

    @action
    getServicefields = async () => {
        const { data: list } = await serviceFields.getList()
        runInAction(() => {
            this.list = list
            this.filterList()
        })
    }

    @action
    filterList = () => {
        this.filteredList = this.list.filter(
            value =>
                (!!value.name && value.name.includes(this.filters['name'])) ||
                value.id.toString() === this.filters['name']
        )
    }

    @action
    setFilter = (name, value) => {
        const newFilters = { ...this.filters }
        newFilters[name] = value
        runInAction(() => {
            this.filters = newFilters
            this.filterList()
        })
    }

    @action
    toggleServicefield = servicefield => {
        if (this.editServicefield['id'] !== servicefield.id) {
            this.editServicefield = { ...servicefield }
        } else {
            this.editServicefield = {}
        }
    }

    @action
    addServicefield = async () => {
        await serviceFields
            .addServicefield({ ...this.editServicefield })
            .then(() => {
                runInAction(() => {
                    this.getServicefields()
                    this.resetEdit()
                })
            })
            .catch(e => {
                runInAction(() => {
                    if (e.response.status === 400) {
                        this.error = '* שם תחום זה כבר קיים'
                    } else {
                        this.error = 'שגיאה בחיבור לשרת'
                    }
                })
            })
    }

    @action
    updateServicefield = async () => {
        await serviceFields
            .updateServicefield({ ...this.editServicefield })
            .then(() => {
                runInAction(() => {
                    this.getServicefields()
                    this.resetEdit()
                })
            })
            .catch(e => {
                runInAction(() => {
                    if (e.response.status === 400) {
                        this.error = '* שם תחום זה כבר קיים'
                    } else {
                        this.error = 'שגיאה בחיבור לשרת'
                    }
                })
            })
    }

    @action
    deleteServicefield = async () => {
        await serviceFields
            .deleteServicefield(this.editServicefield['id'])
            .then(() => {
                runInAction(() => {
                    this.getServicefields()
                    this.resetEdit()
                })
            })
            .catch(e => {
                runInAction(() => {
                    this.error = 'שגיאה בהתחברות לשרת'
                })
            })
    }

    @action
    editValue = (name, value) => {
        this.editServicefield[name] = value
    }

    @action
    resetEdit = () => {
        this.editServicefield = {}
        this.error = null
    }
}

export default remotedev(new servicefieldsStore())
